import { fade, makeStyles } from "@material-ui/core/styles";
// import { green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  // appBar: {
  //   backgroundColor: green[700],
  // },
  menuButton: {
    marginRight: theme.spacing(2),
    marginTop: 3,
  },
  logo: {
    marginLeft: theme.spacing(1),
    display: "inline",
    marginRight: '1rem'
  },
  title: {
    flexGrow: 1,
    marginRight: theme.spacing(5),
    display: "none",
    fontFamily: ["Apple Chancery, cursive", "Roboto", "sans-serif"].join(","),
    color: "#ffffff",
    fontStyle: "italic",
    "&:hover": {
      color: "#ffed21",
    },
    [theme.breakpoints.up("xs")]: {
      display: "inline",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "14ch",
      "&:focus": {
        width: "30ch",
      },
    },
  },
}));

export { useStyles };
